let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4F8sx")).then(() => parcelRequire('6S4DZ'));